// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Paijitang_bottomLine__9DIMt","Paijitang":"Paijitang_Paijitang__1tW9r"};